module.exports = __webpack_public_path__ + "static/media/PDF_84.6f191a11.pdf";